import { columnTypes } from '@/services/Grid/ColumnTypes';
import TooltipComponent from '@/components/Grid/Renderers/TooltipComponent';
import { cloneDeep } from 'lodash';

function FormatPropertyAddress({ data }) {
  const {
    uprn,
    buildingName,
    streetNumber,
    street,
    town,
    postcode,
  } = data.property;

  return [
    buildingName,
    `${streetNumber || ''} ${street || ''}`.trim(),
    town,
    postcode,
  ].filter(Boolean).join(', ');
}

/* Client Actions */
export const assetsInventoryGridDefaultColDef = {
  filter: 'agSetColumnFilter',
  resizable: true,
  sortable: true,
  filterParams: {
    selectAllOnMiniFilter: false,
  },
};

export const assetsInventoryGridColumnTypes = columnTypes;

const grid = [
  {
    headerName: 'ID',
    enablePivot: true,
    field: 'propertyAssetId',
    colId: 'propertyAssetId',
    width: 130,
    minWidth: 130,
    filter: 'agSetColumnFilter',
    checkboxSelection: true,
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    sort: 'asc',
    aggFunc: 'count',
    enableValue: true,
  },
  {
    headerName: 'UPRN',
    enablePivot: true,
    enableRowGroup: true,
    field: 'property.uprn',
    colId: 'property.uprn',
    width: 170,
    minWidth: 170,
  },
  {
    headerName: 'Address',
    enablePivot: true,
    enableRowGroup: true,
    field: '',
    colId: 'address',
    width: 175,
    minWidth: 175,
    cellRenderer: FormatPropertyAddress,
  },
  {
    headerName: 'Postcode',
    enablePivot: true,
    enableRowGroup: true,
    field: 'property.postcode',
    colId: 'property.postcode',
    width: 300,
    minWidth: 300,
    filter: 'agTextColumnFilter',
  },
  {
    headerName: 'Property Status',
    enablePivot: true,
    enableRowGroup: true,
    field: 'property.status',
    colId: 'property.status',
    width: 125,
    minWidth: 125,
    filter: 'agTextColumnFilter',
  },
  {
    headerName: 'Tenure',
    enablePivot: true,
    enableRowGroup: true,
    field: 'property.tenure',
    colId: 'property.tenure',
    width: 125,
    minWidth: 125,
    cellRendererFramework: TooltipComponent,
  },
];

export const assetsPropertiesGridColumns = grid;

export const queryGridColumns = [
  {
    headerName: 'Query With',
    enablePivot: true,
    enableRowGroup: true,
    field: 'queryUser',
    colId: 'queryUser',
    width: 150,
    minWidth: 150,
    filter: 'agSetColumnFilter',
  },
];

export const getAssetsInventoryGridColumns = () => cloneDeep(assetsPropertiesGridColumns);
